import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useRejectedLeads } from "@/hooks/use-rejected-leads";
import { rejectionBucket } from "@/lib/lead-rejection";
import RejectedLeadsDialog from "./RejectedLeadsDialog";

/**
 * Avviste leads i Leadlister (VIB-3032). De vurderes når revurderingsdatoen kommer:
 * tilbake i køen, utsett eller avslutt for godt. Knappen viser hvor mange som venter på vurdering.
 */
export default function RejectedLeadsButton() {
  const [open, setOpen] = useState(false);
  const { data } = useRejectedLeads();
  const due = (data ?? []).filter((l) => rejectionBucket(l.revisit_on) === "due").length;
  if (!data || data.length === 0) return null;

  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)}>
        Avviste{due > 0 ? ` (${due} til vurdering)` : ""}
      </Button>
      <RejectedLeadsDialog open={open} onOpenChange={setOpen} leads={data} />
    </>
  );
}

